/**
 * REST API Url定数
 */
export class RestUrl {
  /** REST API 基底URL */
  public static readonly Base: string = process.env.VUE_APP_REST_URL ? process.env.VUE_APP_REST_URL : "";

  /** ログイン */
  public static readonly Login: string = RestUrl.Base + "/login";
  /** ログアウト */
  public static readonly Logout: string = RestUrl.Base + "/logout";
  /** 施設ログイン */
  public static readonly LoginByFacility: string = RestUrl.Base + "/login/facility";
  /** トークン更新 */
  public static readonly Refresh: string = RestUrl.Base + "/refresh";

  /** フォント */
  public static readonly PdfFont: string = RestUrl.Base + "/facilities/{facilityId}/fonts/pdf";

  /** 施設 */
  public static readonly Facility: string = RestUrl.Base + "/facilities/{facilityId}";

  /** 利用者(複数) */
  public static readonly Residents: string = RestUrl.Base + "/facilities/{facilityId}/residents";
  /** 利用者 */
  public static readonly Resident: string = RestUrl.Base + "/facilities/{facilityId}/residents/{residentId}";
  /** 利用者状態 */
  public static readonly ResidentStatus: string = RestUrl.Base + "/facilities/{facilityId}/residents/{residentId}/status";
  /** 利用者（ケアサポート） */
  public static readonly ResidentsForHitomeQCareSupport: string = RestUrl.Base + "/facilities/{facilityId}/hitomeq-care-supports/residents";
  /** 利用者（i-Medic） */
  public static readonly ResidentsForIMedic: string = RestUrl.Base + "/facilities/{facilityId}/i-medic/residents";
  /** 利用者(移動・コピー) */
  public static readonly ResidentTransfer: string = RestUrl.Base + "/facilities/{facilityId}/residents/{residentId}/transfer";
  /** 家族ユーザー(施設複数) */
  public static readonly FamiliesInFacility: string = RestUrl.Base + "/facilities/{facilityId}/families";
  /** 家族ユーザー(複数) */
  public static readonly Families: string = RestUrl.Base + "/facilities/{facilityId}/families/residents/{residentId}";
  /** 家族ユーザー */
  public static readonly Family: string = RestUrl.Base + "/facilities/{facilityId}/families/{familyId}/residents/{residentId}";
  /** 家族ユーザー(削除用) 削除だけappTypeを使用するので特別に定義している */
  public static readonly DeleteFamily: string = RestUrl.Base + "/facilities/{facilityId}/families/{familyId}/residents/{residentId}/app-type/{appType}";
  /** 家族メールユーザー(複数) */
  public static readonly MailFamilies: string = RestUrl.Base + "/facilities/{facilityId}/mail-families/residents/{residentId}";
  /** 家族メールユーザー */
  public static readonly MailFamily: string = RestUrl.Base + "/facilities/{facilityId}/mail-families/{familyId}/residents/{residentId}";
  /** 利用者グループ */
  public static readonly ResidentGroup: string = RestUrl.Base + "/facilities/{facilityId}/resident-groups/{groupId}";
  /** 利用者グループ(複数) */
  public static readonly ResidentGroups: string = RestUrl.Base + "/facilities/{facilityId}/resident-groups";
  /** 利用者グループメンバー */
  public static readonly ResidentGroupMembers: string = RestUrl.Base + "/facilities/{facilityId}/resident-group-members/{groupId}";

  /** 待機者(複数) */
  public static readonly Waiters: string = RestUrl.Base + "/facilities/{facilityId}/waiters";
  /** 待機者(複数・システム) */
  public static readonly WaitersByIdInSystem: string = RestUrl.Base + "/facilities/{facilityId}/waiters-in-system/{residentIdInSystem}";
  /** 待機者(複数・施設の閲覧可能施設) */
  public static readonly WaitersByOtherFacilities: string = RestUrl.Base + "/facilities/{facilityId}/waiters-in-other-facilities";
  /** 待機者 */
  public static readonly Waiter: string = RestUrl.Base + "/facilities/{facilityId}/waiters/{residentId}";
  /** 待機者変更申請 */
  public static readonly WaiterChangeApplication: string = RestUrl.Base + "/facilities/{facilityId}/waiters/change-applications/{residentIdInSystem}";
  /** 待機者変更申請(不受理) */
  public static readonly WaiterChangeApplicationDelete: string = RestUrl.Base + "/facilities/{facilityId}/waiters/change-applications/delete/{residentIdInSystem}";
  /** 待機者家族(複数) */
  public static readonly WaiterFamilies: string = RestUrl.Base + "/facilities/{facilityId}/waiters/families-in-facility";
  /** 待機者登録URL */
  public static readonly WaiterRegisterUrl: string = RestUrl.Base + "/facilities/{facilityId}/waiters-register-url";
  /** 待機者経過履歴(複数) */
  public static readonly WaiterProgressHistories: string = RestUrl.Base + "/facilities/{facilityId}/waiters/{residentId}/histories";
  /** 待機者経過履歴 */
  public static readonly WaiterProgressHistory: string = RestUrl.Base + "/facilities/{facilityId}/waiters/{residentId}/histories/{historyId}";
  /** 待機者ラベル */
  public static readonly WaiterLabels: string = RestUrl.Base + "/facilities/{facilityId}/waiters/labels";
  /** 待機者ラベル */
  public static readonly WaiterLabel: string = RestUrl.Base + "/facilities/{facilityId}/waiters/labels/{labelId}";
  /** 入所申込テンプレート */
  public static readonly AdmissionApplicationTemplate: string = RestUrl.Base + "/facilities/{facilityId}/admission-application-templates";
  /** 入所評価判定テンプレート */
  public static readonly AdmissionJudgementTemplate: string = RestUrl.Base + "/facilities/{facilityId}/admission-judgement-templates";
  /** 待機者募集情報ページ */
  public static readonly WaiterRecruitments: string = RestUrl.Base + "/facilities/{facilityId}/waiter-recruitments";
  /** 待機者募集情報ページURL */
  public static readonly WaiterRecruitmentUrl: string = RestUrl.Base + "/facilities/{facilityId}/waiter-recruitments-url";

  /** 待機者使用回数 */
  public static readonly WaiterFunctionCounts: string = RestUrl.Base + "/facilities/{facilityId}/waiter-functions/counts";

  /** 施設関係者グループ(複数) */
  public static readonly OtherUserGroups: string = RestUrl.Base + "/facilities/{facilityId}/other-user-groups";
  /** 施設関係者グループ */
  public static readonly OtherUserGroup: string = RestUrl.Base + "/facilities/{facilityId}/other-user-groups/{groupId}";
  /** 施設関係者グループ種類 */
  public static readonly OtherUserGroupTypes: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-types";
  /** 施設関係者グループ種類にひもづくメンバー(複数) */
  public static readonly OtherUserGroupTypeMembers: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-types/{typeId}/other-user-group-members";
  /** 施設関係者グループメンバー */
  public static readonly OtherUserGroupMembersInFacility: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-members/other-user-groups";
  /** 施設関係者グループメンバー(複数) */
  public static readonly OtherUserGroupMembers: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-members/other-user-groups/{groupId}";
  /** 施設関係者グループメンバー */
  public static readonly OtherUserGroupMember: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-members/{memberId}/other-user-groups/{groupId}";
  /** 施設関係者グループメールメンバー(複数) */
  public static readonly MailOtherUserGroupMembers: string = RestUrl.Base + "/facilities/{facilityId}/mail-other-user-group-members/other-user-groups/{groupId}";
  /** 施設関係者グループメールメンバー */
  public static readonly MailOtherUserGroupMember: string = RestUrl.Base + "/facilities/{facilityId}/mail-other-user-group-members/{memberId}/other-user-groups/{groupId}";
  /** 施設関係者グループメンバー(移動・コピー) */
  public static readonly OtherUserGroupMemberTransfer: string = RestUrl.Base + "/facilities/{facilityId}/other-user-groups/{groupId}/members/{memberId}/transfer";

  /** 介護記録(施設) */
  public static readonly CareimagesInFacility: string = RestUrl.Base + "/facilities/{facilityId}/careimages";
  /** 最新介護記録(施設) */
  public static readonly LatestCareimageDateInFacility: string = RestUrl.Base + "/facilities/{facilityId}/careimages/latest";
  /** 介護記録 */
  public static readonly Careimage: string = RestUrl.Base + "/facilities/{facilityId}/careimages/{careimageDate}/residents/{residentId}";
  /** 介護記録(利用者) */
  public static readonly Careimages: string = RestUrl.Base + "/facilities/{facilityId}/careimages/residents/{residentId}";
  /** 介護記録公開状態 */
  public static readonly CareimageStatuses: string = RestUrl.Base + "/facilities/{facilityId}/careimages/statuses";
  /** 介護記録(施設の日付単位) */
  public static readonly CareimageStatusesDatetime: string = RestUrl.Base + "/facilities/{facilityId}/careimages/statuses/{careimageDate}";

  /** イベント(複数) */
  public static readonly Events: string = RestUrl.Base + "/facilities/{facilityId}/events";
  /** イベント */
  public static readonly Event: string = RestUrl.Base + "/facilities/{facilityId}/events/{eventId}";
  /** イベント返信(単一) */
  public static readonly EventReply: string = RestUrl.Base + "/facilities/{facilityId}/event-replies";
  /** イベント返信(単一) */
  public static readonly EventReplies: string = RestUrl.Base + "/facilities/{facilityId}/event-replies/{eventRepliesSortKey}";
  /** イベント返信(イベントにひもづく複数件) */
  public static readonly EventRepliesInEvent: string = RestUrl.Base + "/facilities/{facilityId}/event-replies/event/{eventId}";

  /** メッセージ */
  public static readonly Message: string = RestUrl.Base + "/facilities/{facilityId}/messages/{messageId}";
  /** メッセージ(複数) */
  public static readonly MessagesInFacility: string = RestUrl.Base + "/facilities/{facilityId}/messages";
  /** メッセージ数(機能) */
  public static readonly MessageFunctionCount: string = RestUrl.Base + "/facilities/{facilityId}/messages/count/function";
  /** メッセージ数(月単位) */
  public static readonly MessageMonthlyCount: string = RestUrl.Base + "/facilities/{facilityId}/messages/count/monthly";
  /** メッセージ数(時単位) */
  public static readonly MessageEveryHourCount: string = RestUrl.Base + "/facilities/{facilityId}/messages/count/everyHour";
  /** メッセージ(家族) */
  public static readonly MessagesInFamily: string = RestUrl.Base + "/facilities/{facilityId}/messages/residents/{residentId}/families/{familyId}";
  /** メッセージ設定 */
  public static readonly MessageSettings: string = RestUrl.Base + "/facilities/{facilityId}/messages/message-settings";
  /** メッセージ削除 */
  public static readonly MessageByDatetime: string = RestUrl.Base + "/facilities/{facilityId}/messages/{datetime}";

  /** メッセージ下書き(複数) */
  public static readonly DraftMessages: string = RestUrl.Base + "/facilities/{facilityId}/draft-messages";
  /** メッセージ下書き */
  public static readonly DraftMessage: string = RestUrl.Base + "/facilities/{facilityId}/draft-messages/{id}";

  /** メッセージ送信 */
  public static readonly SendMessages: string = RestUrl.Base + "/facilities/{facilityId}/send-messages";
  /** メッセージ送信(施設関係者) */
  public static readonly SendOtherUserGroupMessages: string = RestUrl.Base + "/facilities/{facilityId}/send-other-user-group-messages";
  /** メール送信 */
  public static readonly SendMailMessages: string = RestUrl.Base + "/facilities/{facilityId}/send-email-messages";
  /** メール送信(施設関係者) */
  public static readonly SendOtherUserGroupMailMessages: string = RestUrl.Base + "/facilities/{facilityId}/send-other-user-group-email-messages";
  /** メッセージ送信(未読/既読) */
  public static readonly SendMessageReadCounts: string = RestUrl.Base + "/facilities/{facilityId}/send-messages/{datetime}/read/counts";
  /** メッセージ送信にひもづく家族 */
  public static readonly SendMessageReadFamilies: string = RestUrl.Base + "/facilities/{facilityId}/send-messages/{datetime}/read/families";
  /** メッセージ送信の返信 */
  public static readonly SendMessageReplies: string = RestUrl.Base + "/facilities/{facilityId}/send-messages/{datetime}/replies";
  /** メッセージ送信の返信への返信 */
  public static readonly SendMessageReplyToFamily: string =
    RestUrl.Base + "/facilities/{facilityId}/send-messages/replies/{parentMessagesSortKey}/residents/{residentId}/families/{familyId}";
  /** メッセージ送信の返信への返信(メール) */
  public static readonly SendEMailReplyToFamily: string =
    RestUrl.Base + "/facilities/{facilityId}/send-email-messages/replies/{parentMessagesSortKey}/residents/{residentId}/families/{familyId}";
  /** メッセージ送信の返信への返信(施設関係者) */
  public static readonly SendMessageReplyToOtherUser: string =
    RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages/replies/{parentMessagesSortKey}/groups/{groupId}/members/{memberId}";
  /** メッセージ送信の返信への返信(施設関係者、メール) */
  public static readonly SendEMailReplyToOtherUser: string =
    RestUrl.Base + "/facilities/{facilityId}/send-other-user-group-email-messages/replies/{parentMessagesSortKey}/groups/{groupId}/members/{memberId}";
  /** 施設のメッセージ送信の返信が存在するか(施設単位) */
  public static readonly SendMessageRepliesUnreadInFacility: string = RestUrl.Base + "/facilities/{facilityId}/send-messages/replies/unread";
  /** 施設のメッセージ送信の返信が存在するか(メッセージ1件) */
  public static readonly SendMessageRepliesUnread: string = RestUrl.Base + "/facilities/{facilityId}/send-messages/{datetime}/replies/unread";
  /** メッセージ送信の返信 */
  public static readonly SendMessageRepliesFamilies: string =
    RestUrl.Base + "/facilities/{facilityId}/send-messages/{datetime}/residents/{residentId}/families/{familyId}/replies/{replyDatetime}";
  /** メッセージ送信テンプレート */
  public static readonly SendMessageTemplate: string = RestUrl.Base + "/facilities/{facilityId}/send-messages/templates/{templateId}";
  /** メッセージ送信テンプレート(複数) */
  public static readonly SendMessageTemplates: string = RestUrl.Base + "/facilities/{facilityId}/send-messages/templates";

  /** 待機者メッセージ送信(未読/既読) */
  public static readonly WaiterSendMessageReadCounts: string = RestUrl.Base + "/facilities/{facilityId}/waiter-send-messages/{datetime}/read/counts";
  /** 施設のメッセージ送信の返信が存在するか(施設単位) */
  public static readonly WaiterSendMessageRepliesUnreadInFacility: string = RestUrl.Base + "/facilities/{facilityId}/waiter-send-messages/replies/unread";
  /** 施設のメッセージ送信の返信が存在するか(メッセージ1件) */
  public static readonly WaiterSendMessageRepliesUnread: string = RestUrl.Base + "/facilities/{facilityId}/waiter-send-messages/{datetime}/replies/unread";

  /** 宛先グループ */
  public static readonly SendMessageGroup: string = RestUrl.Base + "/facilities/{facilityId}/send-message-groups/{groupId}";
  /** 宛先グループ(複数) */
  public static readonly SendMessageGroups: string = RestUrl.Base + "/facilities/{facilityId}/send-message-groups";
  /** 宛先グループメンバー */
  public static readonly SendMessageGroupMembers: string = RestUrl.Base + "/facilities/{facilityId}/send-message-groups/{groupId}/members";

  /** 施設関係者メッセージ(複数) */
  public static readonly OtherUserGroupMessages: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages";
  /** 施設関係者メッセージ送信(未読/既読) */
  public static readonly OtherUserGroupSendMessageReadCounts: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages/{datetime}/read/counts";
  /** 施設関係者メッセージ送信にひもづくメンバー */
  public static readonly OtherUserGroupSendMessageReadMembers: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages/{datetime}/read/members";
  /** メッセージ送信の返信 */
  public static readonly OtherUserGroupSendMessageReplies: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages/{datetime}/replies";
  /** 施設のメッセージ送信の返信が存在するか(施設単位) */
  public static readonly OtherUserGroupSendMessageRepliesUnreadInFacility: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages/replies/unread";
  /** 施設のメッセージ送信の返信が存在するか(メッセージ1件) */
  public static readonly OtherUserGroupSendMessageRepliesUnread: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages/{datetime}/replies/unread";
  /** 施設関係者メッセージ送信の返信 */
  public static readonly OtherUserGroupSendMessageRepliesMembers: string =
    RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages/{datetime}/groups/{groupId}/members/{memberId}/replies/{replyDatetime}";
  /** 施設関係者メッセージ削除 */
  public static readonly OtherUserGroupMessagesByDatetime: string = RestUrl.Base + "/facilities/{facilityId}/other-user-group-messages/{datetime}";

  /** 文書送付(ID指定) */
  public static readonly SendDocument: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/{mainId}";
  /** 文書送付(ID指定なし) */
  public static readonly SendDocuments: string = RestUrl.Base + "/facilities/{facilityId}/send-documents";
  /** 文書送付送信(家族) */
  public static readonly SendDocumentToFamilies: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/{mainId}/families-messages";
  /** 文書送付再送信(家族) */
  public static readonly SendDocumentRemindToFamilies: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/{mainId}/families-messages/remind";
  /** 文書送付送信(施設関係者) */
  public static readonly SendDocumentToOtherUserGroups: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/{mainId}/other-user-groups-messages";
  /** 文書送付再送信(施設関係者) */
  public static readonly SendDocumentRemindToOtherUserGroups: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/{mainId}/other-user-groups-messages/remind";
  /** 文書送付返信 */
  public static readonly SendDocumentReplies: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/{mainId}/replies";
  /** 文書送付返信(利用者) */
  public static readonly SendDocumentRepliesInResident: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/{mainId}/replies/residents/{sortKey}";
  /** 文書送付カテゴリー(ID指定) */
  public static readonly SendDocumentCategory: string = RestUrl.Base + "/facilities/{facilityId}/send-document-categories/{id}";
  /** 文書送付カテゴリー(ID指定なし) */
  public static readonly SendDocumentCategories: string = RestUrl.Base + "/facilities/{facilityId}/send-document-categories";
  /** 文書送付テンプレート */
  public static readonly SendDocumentTemplate: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/templates/{templateId}";
  /** 文書送付テンプレート(複数) */
  public static readonly SendDocumentTemplates: string = RestUrl.Base + "/facilities/{facilityId}/send-documents/templates";

  /** グッドツリー社連携ファイル */
  public static readonly GoodTreeFiles: string = RestUrl.Base + "/facilities/{facilityId}/good-tree-files-primary-key/{goodTreeFilesPrimaryKey}";
  /** iMedic連携ファイル */
  public static readonly IMedicFiles: string = RestUrl.Base + "/facilities/{facilityId}/i-medic-files-primary-key/{iMedicFilesPrimaryKey}";

  /** 意見 */
  public static readonly Opinions: string = RestUrl.Base + "/facilities/{facilityId}/opinions";
  /** 意見メッセージ */
  public static readonly OpinionMessages: string = RestUrl.Base + "/facilities/{facilityId}/opinion-messages/{caseId}";
  /** 意見(施設関係者) */
  public static readonly OtherUserOpinions: string = RestUrl.Base + "/facilities/{facilityId}/other-user-opinions";
  /** 意見メッセージ(施設関係者) */
  public static readonly OtherUserOpinionMessages: string = RestUrl.Base + "/facilities/{facilityId}/other-user-opinion-messages/{caseId}";

  /** 意見(待機者) */
  public static readonly WaiterOpinions: string = RestUrl.Base + "/facilities/{facilityId}/waiter-opinions";
  /** 意見メッセージ(待機者) */
  public static readonly WaiterOpinionMessages: string = RestUrl.Base + "/facilities/{facilityId}/waiter-opinion-messages/{caseId}";

  /** 問い合わせ */
  public static readonly Contacts: string = RestUrl.Base + "/facilities/{facilityId}/contacts";
  /** 問い合わせメッセージ */
  public static readonly ContactMessages: string = RestUrl.Base + "/facilities/{facilityId}/contacts/{caseId}";

  /** 写真(複数) */
  public static readonly Pictures: string = RestUrl.Base + "/facilities/{facilityId}/pictures";
  /** 写真 */
  public static readonly Picture: string = RestUrl.Base + "/facilities/{facilityId}/pictures/{pictureId}";
  /** 写真PDF */
  public static readonly PicturePdf: string = RestUrl.Base + "/facilities/{facilityId}/pictures/{pictureId}/pdf";

  /** 訪問面会予約(複数) */
  public static readonly Reservations: string = RestUrl.Base + "/facilities/{facilityId}/reservations";
  /** 訪問面会予約 */
  public static readonly Reservation: string = RestUrl.Base + "/facilities/{facilityId}/reservations/{reservationId}";
  /** 訪問面会予約 */
  public static readonly ReservationResident: string = RestUrl.Base + "/facilities/{facilityId}/reservations/residents/{residentId}";
  /** 面会予約(承諾) */
  public static readonly ReservationConsented: string = RestUrl.Base + "/facilities/{facilityId}/reservations/{reservationId}/consented";
  /** 面会予約(辞退、キャンセル) */
  public static readonly ReservationDelete: string = RestUrl.Base + "/facilities/{facilityId}/reservations/{reservationId}/consented-delete";
  /** 面会予約(リマインド) */
  public static readonly ReservationsRemind: string = RestUrl.Base + "/facilities/{facilityId}/reservations/year/{year}/month/{month}/date/{date}/remind";
  /** 訪問面会スケジュール */
  public static readonly ReservationSchedules: string = RestUrl.Base + "/facilities/{facilityId}/reservation-schedules/group/{groupId}/year/{year}/month/{month}";
  /** 訪問面会スケジュール(予約可能) */
  public static readonly ReservableSchedules: string =
    RestUrl.Base + "/facilities/{facilityId}/reservable-schedules/group/{groupId}/resident/{residentId}/year/{year}/month/{month}";
  /** 訪問面会設定 */
  public static readonly ReservationSettings: string = RestUrl.Base + "/facilities/{facilityId}/reservation-settings";
  /** オンライン面会予約 */
  public static readonly OnlineReservation: string = RestUrl.Base + "/facilities/{facilityId}/online-reservations/residents/{residentId}";
  /** オンライン面会スケジュール */
  public static readonly OnlineReservationSchedules: string = RestUrl.Base + "/facilities/{facilityId}/online-reservation-schedules/group/{groupId}/year/{year}/month/{month}";
  /** オンライン面会スケジュール(予約可能) */
  public static readonly ReservableOnlineSchedules: string =
    RestUrl.Base + "/facilities/{facilityId}/reservable-online-schedules/group/{groupId}/resident/{residentId}/year/{year}/month/{month}";
  /** オンライン面会設定 */
  public static readonly OnlineReservationSettings: string = RestUrl.Base + "/facilities/{facilityId}/online-reservation-settings";
  /** オンライン面会URL転送 */
  public static readonly TransferOnlineReservationUrl: string = RestUrl.Base + "/facilities/{facilityId}/reservations/{reservationId}/transfer-url";
  /** 面会スケジュールテンプレート(ID指定) */
  public static readonly ReservationScheduleTemplate: string = RestUrl.Base + "/facilities/{facilityId}/reservation-schedules-templates/{id}";
  /** 面会スケジュールテンプレート(ID指定なし) */
  public static readonly ReservationScheduleTemplates: string = RestUrl.Base + "/facilities/{facilityId}/reservation-schedules-templates";

  /** 外出外泊届け */
  public static readonly Outing: string = RestUrl.Base + "/facilities/{facilityId}/outings/{outingId}";
  /** 外出外泊届け（複数） */
  public static readonly Outings: string = RestUrl.Base + "/facilities/{facilityId}/outings";
  /** 外出外泊届け 状態変更 */
  public static readonly OutingsStatus: string = RestUrl.Base + "/facilities/{facilityId}/outings/{outingId}/status";
  /** 外出外泊届け 食事キャンセル情報 */
  public static readonly OutingNeedsMeals: string = RestUrl.Base + "/facilities/{facilityId}/outings/needs-meals";
  /** 外出外泊届け 届け出可能日時（開始） */
  public static readonly OutingAvailableStartDates: string =
    RestUrl.Base + "/facilities/{facilityId}/outings/available-dates/start/type/{type}/resident/{residentId}/year/{year}/month/{month}";
  /** 外出外泊届け 届け出可能日時（終了） */
  public static readonly OutingAvailableEndDates: string =
    RestUrl.Base + "/facilities/{facilityId}/outings/available-dates/end/type/{type}/resident/{residentId}/datetime/{datetime}";
  /** 外出外泊届け設定 */
  public static readonly OutingSetting: string = RestUrl.Base + "/facilities/{facilityId}/outings/settings";

  /** アンケート */
  public static readonly Questionnaire: string = RestUrl.Base + "/facilities/{facilityId}/questionnaires/{questionnaireId}";
  /** アンケート(複数) */
  public static readonly Questionnaires: string = RestUrl.Base + "/facilities/{facilityId}/questionnaires";
  /** アンケート回答(複数) */
  public static readonly QuestionnaireAnswers: string = RestUrl.Base + "/facilities/{facilityId}/questionnaires/{questionnaireId}/answers";
  /** アンケート再送 */
  public static readonly ResendQuestionnaire: string = RestUrl.Base + "/facilities/{facilityId}/questionnaires/{questionnaireId}/resend";

  /** 安否確認 */
  public static readonly SafetyConfirm: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirms/{safetyConfirmsId}";
  /** 安否確認(複数) */
  public static readonly SafetyConfirms: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirms";
  /** 安否確認(家族) */
  public static readonly FamilySafetyConfirm: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirms/family/{safetyConfirmsId}";
  /** 安否確認(家族)テンプレート(単一) */
  public static readonly FamilySafetyConfirmTemplate: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirms-template/family/{familySafetyConfirmsTemplateId}";
  /** 安否確認(家族)質問マスター */
  public static readonly FamilySafetyConfirmMasters: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirm-masters/family";
  /** 安否確認(家族)施設状況 */
  public static readonly SafetyConfirmFacilityStatus: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirm-facility-statuses/{safetyConfirmsId}";
  /** 安否確認(家族)利用者状況(単一) */
  public static readonly SafetyConfirmResidentStatus: string =
    RestUrl.Base + "/facilities/{facilityId}/safety-confirm-resident-statuses/{safetyConfirmsId}/residents/{residentId}/family/{familyId}";
  /** 安否確認(家族)利用者状況(複数) */
  public static readonly SafetyConfirmResidentStatuses: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirm-resident-statuses/{safetyConfirmsId}";
  /** 安否確認(家族)メッセージ送信 */
  public static readonly SendFamilySafetyConfirmMessages: string = RestUrl.Base + "/facilities/{facilityId}/send-safety-confirms-messages/family/{safetyConfirmsId}";
  /** 安否確認(家族)メール送信 */
  public static readonly SendFamilySafetyConfirmMails: string = RestUrl.Base + "/facilities/{facilityId}/send-safety-confirms-messages/family/{safetyConfirmsId}/mails";
  /** 安否確認(施設関係者) */
  public static readonly OtherUserSafetyConfirm: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirms/other-user/{safetyConfirmsId}";
  /** 安否確認(施設関係者)テンプレート(単一) */
  public static readonly OtherUserSafetyConfirmTemplate: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirms-template/other-user/{otherUserSafetyConfirmsTemplateId}";
  /** 安否確認(施設関係者)質問マスター */
  public static readonly OtherUserSafetyConfirmMasters: string = RestUrl.Base + "/facilities/{facilityId}/safety-confirm-masters/other-user";
  /** 安否確認(施設関係者)メッセージ送信 */
  public static readonly SendOtherUserSafetyConfirmMessages: string = RestUrl.Base + "/facilities/{facilityId}/send-safety-confirms-messages/other-user/{safetyConfirmsId}";
  /** 安否確認(施設関係者)メッセージ返信 */
  public static readonly SafetyConfirmReplyMessages: string = RestUrl.Base + "/facilities/{facilityId}/reply-send-safety-confirms-messages/other-user/{messagesSortKey}";
  /** 安否確認(施設関係者)メール送信 */
  public static readonly SendOtherUserSafetyConfirmMails: string = RestUrl.Base + "/facilities/{facilityId}/send-safety-confirms-messages/other-user/{safetyConfirmsId}/mails";

  /** 部屋(ID指定) */
  public static readonly Room: string = RestUrl.Base + "/facilities/{facilityId}/rooms/{roomId}";
  /** 部屋(ID指定なし) */
  public static readonly Rooms: string = RestUrl.Base + "/facilities/{facilityId}/rooms";

  /** 空床情報 */
  public static readonly RoomsSchedules: string = RestUrl.Base + "/facilities/{facilityId}/rooms-schedules/year/{year}/month/{month}";
  /** 空床情報設定 */
  public static readonly RoomsScheduleSettings: string = RestUrl.Base + "/facilities/{facilityId}/vacancy-settings";
  /** 転床情報 */
  public static readonly MoveRoomSchedule: string =
    RestUrl.Base + "/facilities/{facilityId}/move-room-schedules/startDatetime/{startDatetime}/roomId/{roomId}/residentId/{residentId}";
  /** 転床情報(複数) */
  public static readonly MoveRoomSchedules: string = RestUrl.Base + "/facilities/{facilityId}/move-room-schedules";
  /** 転床通知(LINE) */
  public static readonly NotifyRoomSchedulesByLine: string = RestUrl.Base + "/facilities/{facilityId}/notify-room-schedules/line";
  /** 転床通知(MAIL) */
  public static readonly NotifyRoomSchedulesByMail: string = RestUrl.Base + "/facilities/{facilityId}/notify-room-schedules/mail";

  /** カレンダーイベント */
  public static readonly CalendarEvent: string = RestUrl.Base + "/facilities/{facilityId}/calendar-events/{calendarEventId}";
  /** カレンダーイベント(複数) */
  public static readonly CalendarEvents: string = RestUrl.Base + "/facilities/{facilityId}/calendar-events";

  /** マニュアル */
  public static readonly Manuals: string = RestUrl.Base + "/facilities/{facilityId}/manuals";

  /** お知らせ(複数) */
  public static readonly Notifications: string = RestUrl.Base + "/facilities/{facilityId}/notifications";
  /** お知らせ */
  public static readonly Notification: string = RestUrl.Base + "/facilities/{facilityId}/notifications/{notificationId}";
  /** 未読お知らせ件数 */
  public static readonly UnconfirmedNotificationCount: string = RestUrl.Base + "/facilities/{facilityId}/notifications/count/unconfirmed";
  /** 操作履歴(複数) */
  public static readonly FunctionHistories: string = RestUrl.Base + "/facilities/{facilityId}/function-histories";

  /** S3公開URL */
  public static readonly PublicS3Url: string = RestUrl.Base + "/facilities/{facilityId}/s3url";
  /** S3格納先URL */
  public static readonly S3Locations: string = RestUrl.Base + "/facilities/{facilityId}/s3url/locations";
  /** S3格納先URL */
  public static readonly S3MultiLocations: string = RestUrl.Base + "/facilities/{facilityId}/s3url/multi-locations";
  /** S3ファイル存在確認 */
  public static readonly ExistS3Files: string = RestUrl.Base + "/facilities/{facilityId}/exist-s3-files";

  /** フォロワー */
  public static readonly Followers: string = RestUrl.Base + "/facilities/{facilityId}/followers";
  /** フォロワーメッセージ送信 */
  public static readonly FollowerMessages: string = RestUrl.Base + "/facilities/{facilityId}/send-follower-messages";

  /** 施設見学予約(単一) */
  public static readonly InspectionReservation: string = RestUrl.Base + "/facilities/{facilityId}/inspection-reservations/{inspectionReservationsSortKey}";
  /** 施設見学予約(複数) */
  public static readonly InspectionReservations: string = RestUrl.Base + "/facilities/{facilityId}/inspection-reservations";

  /** 入所募集問い合わせ(単一) */
  public static readonly RecruitmentContact: string = RestUrl.Base + "/facilities/{facilityId}/recruitment-contacts/{recruitmentContactsSortKey}";
  /** 入所募集問い合わせ(複数) */
  public static readonly RecruitmentContacts: string = RestUrl.Base + "/facilities/{facilityId}/recruitment-contacts";

  /** 他事業所連携(複数) */
  public static readonly OtherOfficeConnections: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections";
  /** 他事業所連携招待メール送信 */
  public static readonly OtherOfficeConnectionMail: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/send-mail";

  /** 他事業所連携メッセージ */
  public static readonly OtherOfficeMessage: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/{otherOfficeFacilityId}/messages/{datetime}";
  /** 他事業所連携メッセージ(複数) */
  public static readonly OtherOfficeMessages: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/{otherOfficeFacilityId}/messages";
  /** 他事業所連携返信メッセージ */
  public static readonly OtherOfficeReplyMessage: string =
    RestUrl.Base + "/facilities/{facilityId}/other-office-connections/{otherOfficeFacilityId}/messages/{datetime}/reply/{replyDatetime}";
  /** 他事業所連携返信メッセージ(複数) */
  public static readonly OtherOfficeReplyMessages: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/{otherOfficeFacilityId}/messages/{datetime}/reply";

  /** 他事業所連携 オンライン会議 */
  public static readonly OtherOfficeOnlineMeeting: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/{otherOfficeFacilityId}/online-meetings";
  /** 他事業所連携 オンライン会議 */
  public static readonly OtherOfficeOnlineMeetingById: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/{otherOfficeFacilityId}/online-meetings/{id}";
  /** 他事業所連携 オンライン会議(複数) */
  public static readonly OtherOfficeOnlineMeetings: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/online-meetings";

  /** 他事業所連携 空床情報 */
  public static readonly OtherOfficeRoomSchedules: string = RestUrl.Base + "/facilities/{facilityId}/other-office-room-schedules/year/{year}/month/{month}";
  /** 他事業所連携 空床受入リクエスト */
  public static readonly OtherOfficeAcceptanceRequests: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/acceptance-requests";
  /** 他事業所連携 空床受入リクエスト */
  public static readonly OtherOfficeAcceptanceRequest: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/acceptance-requests/{datetime}";
  /** 他事業所連携受入リクエスト未返信存在可否取得 */
  public static readonly NoreplyOtherOfficeAcceptanceRequestCount: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/acceptance-requests/noreplies/count";
  /** 他事業所連携 空床受入リクエスト返信 */
  public static readonly OtherOfficeAcceptanceRequestReplies: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/acceptance-requests/replies/{datetime}";
  /** 他事業所連携 空床受入リクエスト返信 */
  public static readonly OtherOfficeAcceptanceRequestReply: string = RestUrl.Base + "/facilities/{facilityId}/other-office-connections/acceptance-requests/replies";

  /** ユーザーアカウント */
  public static readonly Accounts: string = RestUrl.Base + "/facilities/{facilityId}/accounts";
  /** ユーザーアカウント(一般ユーザー登録) */
  public static readonly AccountsRegister: string = RestUrl.Base + "/facilities/{facilityId}/accounts/standard-user";
  /** ユーザーアカウント(一般ユーザー削除) */
  public static readonly AccountsDelete: string = RestUrl.Base + "/facilities/{facilityId}/accounts/delete";
  /** ユーザーアカウント（ユーザー存在可否） */
  public static readonly ExistAccount: string = RestUrl.Base + "/facilities/{facilityId}/accounts/exists";

  /** 家族・施設関係者のLINEbot操作の通知設定 */
  public static readonly NotificationSettings: string = RestUrl.Base + "/facilities/{facilityId}/notifications/notification-settings";

  /** 家族連絡サービスプラン */
  public static readonly Plans: string = RestUrl.Base + "/facilities/{facilityId}/plans";
  /** 家族連絡サービスプラン変更 */
  public static readonly PlanRequests: string = RestUrl.Base + "/facilities/{facilityId}/plans/request";
  /** 待機者管理サービスプラン */
  public static readonly WaiterPlans: string = RestUrl.Base + "/facilities/{facilityId}/waiter-plans";
  /** 待機者管理サービスプラン変更 */
  public static readonly WaiterPlanRequests: string = RestUrl.Base + "/facilities/{facilityId}/waiter-plans/request";

  /** 入所者募集・待機者管理サービスプラン */
  public static readonly WaiterServicePlans: string = RestUrl.Base + "/facilities/{facilityId}/waiter-service-plans";
  /** 入所者募集・待機者管理サービスプラン変更 */
  public static readonly WaiterServicePlanRequests: string = RestUrl.Base + "/facilities/{facilityId}/waiter-service-plans/request";

  /** 解約 */
  public static readonly Terminations: string = RestUrl.Base + "/facilities/{facilityId}/terminations";

  /** システム設定 */
  public static readonly SystemSettings: string = RestUrl.Base + "/system-settings";

  /** 祝日 */
  public static readonly NationalHolidays: string = RestUrl.Base + "/facilities/{facilityId}/national-holidays";

  /** 地域情報 */
  public static readonly RegionMasters: string = RestUrl.Base + "/facilities/{facilityId}/region-masters";

  /** エラー収集 */
  public static readonly ErrorCollections: string = RestUrl.Base + "/facilities/{facilityId}/error-collections";

  /** S3Url */
  public static readonly S3Url: string = process.env.VUE_APP_S3_URL ? process.env.VUE_APP_S3_URL : "";
}
